import React from "react";
import Slider from "react-slick";
import { ProvenIcon, StrongIcon, QuickIcon, BussinessIcon, SettingsIcon } from './Icon';

const WhyChooseCarousel = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 5000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false, 
  };

  return (
    <div style={{ width: "100%" }}>
      <Slider {...settings} className='client-slider'>
        <div className="card-other">
          <h2 className='icon-style'><ProvenIcon></ProvenIcon></h2>
          <p className="octo-other-para ">Proven track record of successful placements across India</p>
        </div>
        <div className="card-other">
          <h2 className='icon-style'><StrongIcon></StrongIcon></h2>
          <p className="octo-other-para ">Strong network of 500+ freelance recruiters</p>
        </div>
        <div className="card-other">
          <h2 className='icon-style'><QuickIcon></QuickIcon></h2>
          <p className="octo-other-para ">Quick turnaround time and 3-month free replacement guarantee</p>
        </div>
        <div className="card-other">
          <h2 className='icon-style'><BussinessIcon></BussinessIcon></h2>
          <p className="octo-other-para ">Transparent and ethical business practices</p>
        </div>
        <div className="card-other">
          <h2 className='icon-style'><SettingsIcon></SettingsIcon></h2>
          <p className="octo-other-para ">Customized recruitment strategies tailored to your needs</p>
        </div>
      </Slider>
    </div>
  );
};

export default WhyChooseCarousel;
